module.exports = __webpack_public_path__ + "img/documedias_logo.b798a575.png";